import React from 'react';
import classNames from 'classnames';
import { IconLoader2 } from '@tabler/icons-react';
import { getCardStatusLabel } from '@entities/messanger';
import s from './interactive-message.module.scss';
import { useCardAction } from '../model/use-card-action';

// Универсальный рендер карточки по контракту от бэка (message.card):
// { status, title, lines: string[], actions: [{ key, label, method, url }] }
// lines уже отформатированы по-русски — рендерим как есть.
export const EntityCard = ({ card, message, icon, headerRight, onCardClick }) => {
  const { run, pendingKey } = useCardAction(message?.chat_id);

  if (!card) return null;

  const actions = card.actions || [];
  const showStatus = card.status && card.status !== 'active';

  return (
    <div
      className={classNames(s.interactiveCard, onCardClick && s.clickable)}
      onClick={onCardClick}
      role={onCardClick ? 'button' : undefined}
    >
      <div className={s.header}>
        {icon && <span className={s.icon}>{icon}</span>}
        <span className={s.title}>{card.title}</span>
        {headerRight}
        {showStatus && (
          <span className={classNames(s.statusBadge, s[card.status])}>
            {getCardStatusLabel(card.status)}
          </span>
        )}
      </div>
      {Array.isArray(card.lines) && card.lines.length > 0 && (
        <div className={s.lines}>
          {card.lines.map((line, index) => (
            <span key={index} className={s.line}>
              {line}
            </span>
          ))}
        </div>
      )}
      {actions.length > 0 && (
        // Клики по действиям не должны всплывать на кликабельную карточку
        <div className={s.actions} onClick={(e) => e.stopPropagation()}>
          {actions.map((action) => {
            const isPending = pendingKey === `${message?.id}:${action.key}`;
            const isDisabled = isPending || action.disabled;
            return (
              <button
                key={action.key}
                type="button"
                className={s.actionBtn}
                disabled={isDisabled}
                title={action.disabled ? action.disabledReason : undefined}
                onClick={() => run(action, message)}
              >
                {isPending ? (
                  <IconLoader2 size={16} className={s.spin} />
                ) : (
                  action.label
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
